/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Styled component for Tab
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../theme';

export const TabBtnStyled = styled.div`
    position: relative;
    flex: 1 0 auto;
    padding: 12px 24px;
    height: 48px;
    text-align: center;
    color: ${colors.pageDashboardWidgetText};
    cursor: pointer;
    ${fonts.textMainBold};

    &::before {
        display: block;
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: 1px solid ${colors.pageDashboardBorderBottomNoActive};
    }

    &:hover {
        color: ${colors.pageDashboardBorderBottomActive};
    }

    &.active {
        color: ${colors.pageDashboardBorderBottomActive};

        &::before {
            border-bottom: 2px solid ${colors.pageDashboardBorderBottomActive};
        }
    }
`;
